import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GoogleDriveSaveModal.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GoogleDriveSaveModal.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GoogleDriveSaveModal.vue?vue&type=script&lang=js&
// module id = 996
// module chunks = 1